import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-surface-1 to-surface-2 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center">
        {/* Ilustración 404 */}
        <div className="relative mb-8">
          <div className="text-[180px] font-bold text-brand/10 leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 bg-brand/10 rounded-full flex items-center justify-center">
              <Search className="w-16 h-16 text-brand/40" />
            </div>
          </div>
        </div>

        {/* Texto */}
        <h1 className="text-h2 font-display text-primary mb-3">
          Página no encontrada
        </h1>
        <p className="text-body text-secondary mb-8 max-w-md mx-auto">
          Lo sentimos, la página que buscas no existe o ha sido movida. 
          Verifica la URL o regresa al inicio.
        </p>

        {/* Acciones */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button type="button"
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-default bg-surface-0 text-primary font-medium hover:bg-surface-hover transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver atrás
          </button>
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-brand text-white font-medium hover:bg-brand-hover transition-colors"
          >
            <Home className="w-4 h-4" />
            Ir al inicio
          </Link>
        </div>

        {/* Información adicional */}
        <p className="mt-12 text-caption text-tertiary">
          Si crees que esto es un error, contacta a soporte.
        </p>
      </div>
    </div>
  );
}



